export const SMALL_NOTE_OPEN_TAG = '<font_params font_size=9>';
export const SMALL_NOTE_CLOSE_TAG = '</font_params>';

export const decodeCollegeEligibilityNote = (value: string): string => {
  if (value.startsWith(SMALL_NOTE_OPEN_TAG) && value.endsWith(SMALL_NOTE_CLOSE_TAG)) {
    return value.slice(SMALL_NOTE_OPEN_TAG.length, -SMALL_NOTE_CLOSE_TAG.length);
  }
  return value;
};
